

document.getElementById('prdct_outer').onclick = function() {

    var className = ' ' + prdct_outer.className + ' ';

    this.className = ~className.indexOf(' active ') ?
                         className.replace(' active ', ' ') :
                         this.className + ' active';
};


 
jQuery(document).ready(function(){
    jQuery(".foil_enable input").click(function(){
       jQuery(".foil_view").toggle();
    });
});



jQuery(document).ready(function() {
    jQuery('.header_trigger_new ').on('click', function() {
		
        if(jQuery("body").hasClass('is-mobile-nav-open'))
        {
            jQuery("body").removeClass('is-mobile-nav-open');
        }else{
            jQuery("body").addClass('is-mobile-nav-open');
        }        
    });    

});   


jQuery(document).ready(function() {
    jQuery('.header_trigger_new ').on('click', function() {
		
        if(jQuery("html").hasClass('add_style'))
        {
            jQuery("html").removeClass('add_style');
        }else{
            jQuery("html").addClass('add_style');
        }        
    });    

});   



jQuery(document).ready(function() {
    jQuery('.mb_selector').on('click', function() {
		
        if(jQuery(".wh_country").hasClass('wh_country_active'))
        {
            jQuery(".wh_country").removeClass('wh_country_active');
        }else{
            jQuery(".wh_country").addClass('wh_country_active');
        }        
    });    

});   





jQuery(document).ready(function() {
    jQuery('.header__primary__toggle , .header__primary__submenu__back').on('click', function() {
		
        if(jQuery(".header__primary__submenu").hasClass('active'))
        {
            jQuery(".header__primary__submenu").removeClass('active');
        }else{
            jQuery(".header__primary__submenu").addClass('active');
        }        
    });    

});   


